import { inject, Injectable } from '@angular/core';
import { SiaAIPromptApi } from './ai-prompt.api';

@Injectable({
  providedIn: 'root',
})
export class SiaAIPromptService {
  #api = inject(SiaAIPromptApi);

  applyPrompt(promptId: number, parameters: any): Promise<string> {
    return this.#api.applyPrompt(promptId, parameters);
  }
}
